import { Injectable } from "@angular/core";
import { TerminalStatement, TerminalStatementClient } from "../WebApiClient";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class TerminalStatementService {
    constructor(
        private readonly terminalStatementClient: TerminalStatementClient
    ) {}

    getTerminalStatements(): Observable<TerminalStatement[] | undefined> {
        let o = this.terminalStatementClient.getTerminalStatements().pipe(
            map((c) => {
                return c.terminalStatements;
            })
        );
        return o;
    }
}
